import React, { useState, useEffect } from 'react'
import { Link } from '@paypalcorp/pp-react'

// set the number of initial characters to show to 100 for now
const MAX_LENGTH = 100
//Do not pass a string smaller than 100 characters or it will break the UI experience. So maxLength should be used to truncate the string before html.
const ReadMoreText = ({
  entireText,
  readMoreText,
  showLessText,
  maxLength = MAX_LENGTH,
  fptiEvent = () => {}
}: {
  entireText: string | string[]
  readMoreText: string
  showLessText: string
  maxLength?: number
  fptiEvent?: () => void
}): JSX.Element | null => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isSSR, setIsSSR] = useState(true)

  useEffect(() => {
    setIsSSR(false)
  }, [])
  if (!entireText || !entireText.toString().length) {
    return null
  }
  const readMoreLink = (
    <Link
      data-cy="readMoreButton"
      href=""
      className="store-details__links"
      // TODO
      // This link should have the props as="button"
      // and the event type should be React.MouseEvent<HTMLButtonElement>
      onClick={(e: { preventDefault: () => void }) => {
        e.preventDefault()
        setIsExpanded(!isExpanded)
        fptiEvent()
      }}
    >
      {isExpanded ? showLessText : readMoreText}
    </Link>
  )
  let textToShow = null
  // If rendering on the server, show the whole text for SEO purposes.
  // Also, if the text is shorter than MAX_LENGTH, show the whole text.
  // Otherwise, add the "Read More/Show Less" link
  if (isSSR || entireText.toString().length <= maxLength) {
    textToShow = entireText
  } else if (isExpanded) {
    textToShow = (
      <>
        {entireText} {readMoreLink}
      </>
    )
  } else {
    const displayText = Array.isArray(entireText)
      ? entireText.join('')
      : entireText
    const shortText = displayText.slice(0, maxLength) + '...'
    textToShow = (
      <>
        {shortText} {readMoreLink}
      </>
    )
  }

  return (
    <div
      className="store-details__merchant-description"
      data-cy="storeDescription"
    >
      {textToShow}
    </div>
  )
}

export default ReadMoreText
